<div class="main-image" [ngStyle]="{'background-image': 'url(' + environment.image_url + activeImage + ')'}"></div>
<ul>
	<li *ngFor="let image of images" [ngClass]="{active: image.imageName == activeImage}" (click)="setActiveImage(image.imageName)"><div class="small-image" [ngStyle]="{'background-image': 'url(' + environment.image_url + image.imageName + ')'}"></div></li>
</ul>